import { useSelector } from 'react-redux';
import {
  isAdminUserSelector,
  isAgentUserSelector,
  isDriverUserSelector,
  isPartnerUserSelector,
  isSuperAdminUserSelector,
} from 'src/features/user/store';

export const useUserRole = () => {
  const isDriver = useSelector(isDriverUserSelector);
  const isAdmin = useSelector(isAdminUserSelector);
  const isAgent = useSelector(isAgentUserSelector);
  const isSupperAdmin = useSelector(isSuperAdminUserSelector);
  const isPartner = useSelector(isPartnerUserSelector);

  let LEVEL_MANAGER = false;
  let LEVEL_AGENT = false;
  let LEVEL_PARTNER = false;
  let LEVEL_DRIVER = false;

  if (isSupperAdmin || isAdmin) {
    LEVEL_MANAGER = true;
  }

  if (isAdmin || isSupperAdmin || isAgent) {
    LEVEL_AGENT = true;
  }

  if (isAdmin || isSupperAdmin || isAgent || isPartner) {
    LEVEL_PARTNER = true;
  }

  if (isAdmin || isSupperAdmin || isAgent || isPartner || isDriver) {
    LEVEL_DRIVER = true;
  }

  return {
    LEVEL_AGENT,
    LEVEL_DRIVER,
    LEVEL_MANAGER,
    LEVEL_PARTNER,
    isDriver,
    isAdmin,
    isAgent,
    isSupperAdmin,
    isPartner,
  };
};
